<ngx-charts-polar-chart *ngIf="init" [scheme]="chartOptions.colorScheme" [results]="data.data"
  [gradient]="chartOptions.gradient" [xAxis]="chartOptions.showXAxis" [yAxis]="chartOptions.showYAxis"
  [legend]="chartOptions.showLegend" [showXAxisLabel]="chartOptions.showXAxisLabel"
  [showYAxisLabel]="chartOptions.showYAxisLabel" [xAxisLabel]="chartOptions.xAxisLabel"
  [yAxisLabel]="chartOptions.yAxisLabel" (select)="onSelect($event)" [yAxisMinScale]="chartOptions.yAxisMinScale"
  [view]="chartOptions.view">
</ngx-charts-polar-chart>